// extracted by mini-css-extract-plugin
export default {"chartWrapper":"Last30DaysViews_chartWrapper__q6vgn","legend":"Last30DaysViews_legend__qd5XX","btn":"Last30DaysViews_btn__zi1P7"};